import {Box, CardHeaderProps, Stack, Tooltip, Typography} from "@mui/material"
import MessageReference from "./MessageReference"
import {CountryAvatar} from "../../../../components/icons/CountryAvatar";

type MessageHeaderProps =
  Omit<CardHeaderProps, 'avatar' | 'title' | 'subheader' | 'sx'> & {
  idSistemaPrincipal: number
  nombreSistemaPrincipal: string
  nombreSistema: string
  referencia: string
  nombreEtapaActual: string
}

const MessageHeader = (props: MessageHeaderProps) => {
  const {idSistemaPrincipal, nombreSistema, nombreSistemaPrincipal, referencia, nombreEtapaActual, action} = props

  return (
    <Box sx={{px: 2, pt: 2, pb: 1}}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1.25} minWidth={0}>
        <Stack direction='row' alignItems='center' spacing={1} minWidth={0}>
          <CountryAvatar
            countryCode={idSistemaPrincipal}
            sx={{height: '24px', width: '24px', flexShrink: 0}}
          />
          <Tooltip title={referencia}>
            <Typography noWrap variant='body2' color='text.secondary' sx={{minWidth: 0}}>
              <Box component='span' sx={{fontWeight: 600}}>
                Ref.:{' '}
              </Box>
              {referencia}
            </Typography>
          </Tooltip>
        </Stack>

        {action}
      </Stack>

      <Tooltip title={nombreSistema}>
        <Typography noWrap variant='subtitle1' sx={{fontWeight: 700, mt: 0.75, minWidth: 0}}>
          {nombreSistema}
        </Typography>
      </Tooltip>

      <Box sx={{mt: 0.25}}>
        <MessageReference referencia={referencia} nombreEtapaActual={nombreEtapaActual} hideReferencia/>
      </Box>
    </Box>
  )
}

export default MessageHeader
